export const GAME_TITLE = 'Cata-Letras'

export const WIN_MESSAGES = ['Parabéns!']
export const GAME_COPIED_MESSAGE = 'Jogo copiado para o clipboard'
export const NOT_ENOUGH_LETTERS_MESSAGE = 'Não tem letras suficientes'
export const WORD_NOT_FOUND_MESSAGE = 'Palavra não aceite'
export const HARD_MODE_ALERT_MESSAGE =
  'O modo difícil só pode ser ativado no início do jogo!'
export const HARD_MODE_DESCRIPTION =
  'Dicas reveladas devem ser usadas nas tentativas seguintes'
export const HIGH_CONTRAST_MODE_DESCRIPTION = 'For improved color vision'
export const CORRECT_WORD_MESSAGE = (solution: string) =>
  `A palavra era ${solution}`
export const WRONG_SPOT_MESSAGE = (guess: string, position: number) =>
  `Deve usar a letra ${guess} na posição ${position}`
export const NOT_CONTAINED_MESSAGE = (letter: string) =>
  `O palpite deve conter a letra ${letter}`
export const ENTER_TEXT = 'Enter'
export const DELETE_TEXT = 'Apagar'
export const STATISTICS_TITLE = 'Estatísticas'
export const GUESS_DISTRIBUTION_TEXT = 'Distribuição dos palpites'
export const NEW_WORD_TEXT = 'Próxima palavra em'
export const SHARE_TEXT = 'Compartilhar'
export const TOTAL_TRIES_TEXT = 'Total de tentativas'
export const SUCCESS_RATE_TEXT = 'Taxa de sucesso'
export const CURRENT_STREAK_TEXT = 'Sequência atual'
export const BEST_STREAK_TEXT = 'Melhor sequência'
export const DISCOURAGE_INAPP_BROWSER_TEXT =
  "You are using an embedded browser and may experience problems sharing or saving your results. We encourage you rather to use your device's default browser."
